import { defineMessages } from "@formatjs/intl"
import type { PreviousOwnerUsageHistoryOptions } from "./PreviousOwnerUsageHistoryOptions"

export const previousOwnerUsageHistoryOptionsMessages = defineMessages<PreviousOwnerUsageHistoryOptions>({
	BUSINESS: {
		defaultMessage: "Business / Commercial",
		id: "conditionAndHistory.previousOwnerUsageHistory.business",
	},
	OTHER: {
		defaultMessage: "Other",
		id: "conditionAndHistory.previousOwnerUsageHistory.others",
	},
	PRIVATE: {
		defaultMessage: "Private",
		id: "conditionAndHistory.previousOwnerUsageHistory.private",
	},
	RENTAL: {
		defaultMessage: "Rental",
		id: "conditionAndHistory.previousOwnerUsageHistory.rental",
	},
})
